'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wrapDispatch = exports.bindActionCreators = undefined;

var _immutableMultireducer = require('./immutableMultireducer');

var _immutableMultireducer2 = _interopRequireDefault(_immutableMultireducer);

var _bindActionCreators = require('./bindActionCreators');

var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);

var _wrapDispatch = require('./wrapDispatch');

var _wrapDispatch2 = _interopRequireDefault(_wrapDispatch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.bindActionCreators = _bindActionCreators2.default;
exports.wrapDispatch = _wrapDispatch2.default;
exports.default = _immutableMultireducer2.default;